import React from "react";

const EmptyTable = ({isApiLoading}) => {
  return (
    <div className="text-center space-y-4 py-6">
      {/* <img src={NoData} alt="Bereload Nodata" className="mx-auto" /> */}
      <span className="text-gray-700 font-medium text-sm ">
        {/* No data to display. */}
        {isApiLoading ? "Data Loading...." :"No data to display."}
        {/* Data Loading.... */}
      </span>
    </div>
  );
};

export default EmptyTable;
